import { Nullable } from "@tager/admin-services";
import { OptionType } from "@tager/admin-ui";

import { BasisProductParam, FullBasisProductType } from "@/typings/model";
import {
  BasisProductCreationPayload,
  BasisProductUpdatePayload,
} from "@/services/requests";

export type FormValues = {
  name: string;
  params: Array<BasisProductParam>;
  products: Array<{
    options: Array<{
      id: number;
      name: string;
    }>;
    product: Nullable<OptionType<number>>;
  }>;
};

export function convertBasisProductToFormValues(
  basisProduct: Nullable<FullBasisProductType>
): FormValues {
  if (!basisProduct) {
    return {
      name: "",
      params: [],
      products: [],
    };
  }

  const products = basisProduct.products.map((productParams) => {
    return {
      options: productParams.options,
      product: productParams.product
        ? {
            value: productParams.product.id,
            label: productParams.product.fullName,
          }
        : null,
    };
  });

  return {
    name: basisProduct.name ?? "",
    params: basisProduct.params ?? [],
    products: products ?? [],
  };
}

export function convertFormValuesToBasisProductCreationPayload(
  values: FormValues
): BasisProductCreationPayload {
  return {
    name: values.name ?? "",
    params: values.params ?? [],
    products: values.products.map((productParam) => {
      return {
        options: productParam.options.map((option) => option.id),
        product: productParam.product?.value ?? null,
      };
    }),
  };
}

export function convertFormValuesToBasisProductUpdatePayload(
  values: FormValues
): BasisProductUpdatePayload {
  return {
    ...convertFormValuesToBasisProductCreationPayload(values),
  };
}

export function createProductTable(params: Array<BasisProductParam>) {
  const tableConfig = params.map((param, index) => {
    return {
      id: index + 1,
      name: param.name,
      field: `option-${index}`,
    };
  });
  tableConfig.push({
    id: 4,
    name: "Товары",
    field: `products`,
  });

  return tableConfig;
}

export function moveItem<T>(
  itemList: Array<T>,
  itemIndex: number,
  direction: "up" | "down"
) {
  if (
    (direction === "up" && itemIndex === 0) ||
    (direction === "down" && itemIndex === itemList.length - 1)
  ) {
    return;
  }

  const item = itemList[itemIndex];

  itemList.splice(itemIndex, 1);
  itemList.splice(direction === "up" ? itemIndex - 1 : itemIndex + 1, 0, item);
}
